<style>
.edi-info {
	overflow: hidden;
}
.edi-info-head {
	width: 94px;
	height: 94px;
	padding-left: 50%;
	margin-top: 2em;
	margin-left: -47px;
	margin-bottom: 1em;
}
.edi-info .foot ul {
	position: absolute;
	width: 100%;
	bottom: 0;
	margin: 0;
	padding: 0;
	background-color: #f8f8f8;
	border-top: 1px #d1d1d1 solid;
}
.edi-info .acc-secure {
	margin-top: .5em;
}
.edi-info .ui-listview,
.edi-info .ui-listview li {
	border: none;
}
.edi-info .ui-listview li > a {
	display: block;
	padding: .7em 1em;
}
.edi-info .ui-listview {
	margin-bottom: 1em;
}
.edi-info .ui-listview li span {
	color: #666;
	padding: .7em 0;
	line-height: 1.5em;
}
.edi-info .ui-col-3 {
	margin-right: 5%;
	text-align: right;
	width: 25% !important;
	vertical-align: top;
}
.edi-info .ui-col-7 {
	margin-right: 4%;
	width: 64% !important;
	color:#666;
	padding: .8em 0 .7em 0;
}
</style>

<template>
<div class="edi-info" :style="{ 'height': deviceHeight }">
  <img class="edi-info-head" :src="store.sysInfo && store.sysInfo.logo || ''">
	<ul class="ui-listview">
		<li>
			<span class="ui-col-3">企业名称</span>
			<input type="text" class="ui-col-7" v-model="companyInfo.name" />
		</li>
		<li>
			<span class="ui-col-3">企业账号</span>
			<span class="ui-col-7">{{companyInfo.code}}</span>
		</li>
		<li>
			<span class="ui-col-3">详细地址</span>
			<input type="text" class="ui-col-7" v-model="companyInfo.address" />
		</li>
	</ul>
	<fieldset class="ui-controlgroup" style="padding: 0 .5em">
		<input type="submit" value="保存修改" class="submit" @click="modifySave" />
	</fieldset>
	<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
</div>
</template>
<!--{{{ script -->
<script>
import TipsAuto from '../components/TipsAuto'
import Config from '../configs'
import { GlobalStore } from '../store/globalStore'
export default {
	data () {
		return {
			tipsauto: false,
			tipsFont: '',
			sec: 1500,
			deviceHeight: this.$root.deviceHeight,
			transitionName: 'page-next',
			companyInfo: {},
			chinesePatrn: /^[\u2E80-\u9FFF]+$/,
			config: Config,
			store: GlobalStore
		}
	},
	created () {
		this.$http.get('/cldEdi/business/getCompany').then(response => {
			this.companyInfo = response.body.data
		}, (response) => {
			this.tips = true
			this.tipsFont = '服务中断，稍后请重试！'
		})
	},
	components: {
		'tips-auto': TipsAuto
	},
	methods: {
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		modifySave () {
			if (this.companyInfo.name === '') {
				this.autoTips('企业名称不能为空')
				return false
			} else if (!(this.chinesePatrn.test(this.companyInfo.name))) {
				this.autoTips('企业名称只能是汉字')
				return false
			} else if (this.companyInfo.name.length > 30) {
				this.autoTips('企业名称最大长度为30个字符')
				return false
			}
			this.$http.post('/cldEdi/business/updateCompany', this.companyInfo).then(response => {
				var data = response.body
				if (!data.result) {
					this.tips = true
					this.tipsFont = data.message
					return false
				}
				this.$router.push('/main/my')
			}, (response) => {
				this.tips = true
				this.tipsFont = '服务中断，稍后请重试！'
			})
		}
	}
}
</script>
<!--}}}-->



// WEBPACK FOOTER //
// Infomation.vue?3e79ff1c